export const revenueSharingRouter = [
  {
    path: '/splitAccountReview',
    name: 'reviewList',
    component: () => import('@/views/revenueSharingManagement/reviewList'),
    meta: {
      title: '分账复核',
      keepAlive: true
    }
  },
  {
    path: '/splitAccountReview/reviewSearch',
    name: 'reviewSearch',
    component: () => import('@/views/revenueSharingManagement/reviewSearch'),
    meta: {
      title: '搜索'
    }
  },
  {
    path: '/splitAccountReview/selectedSubmitter',
    name: 'selectedSubmitter',
    component: () => import('@/views/revenueSharingManagement/selectedSubmitter'),
    meta: {
      title: '选择'
    }
  },
  {
    path: '/splitAccountReview/reviewDetails',
    name: 'reviewDetails',
    component: () => import('@/views/revenueSharingManagement/reviewDetails'),
    meta: {
      title: '分账复核详情'
    }
  }
]
